export async function addText(data: string, insertInNewLine: boolean = false): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    switch (Office.context.host) {
      case Office.HostType.PowerPoint: {
        await PowerPoint.run(async function (context) {
          try {
            const dataWriteResponse = await new Promise(async (resolve, reject) => {
              await Office.context.document.setSelectedDataAsync(
                insertInNewLine ? `\r${data}` : data,
                function (result) {
                  if (result.status === Office.AsyncResultStatus.Succeeded) {
                    resolve(true);
                  } else {
                    const err = result.error;
                    console.log(err.name + ": " + err.message);
                    reject(err);
                  }
                }
              );
            });
            if (dataWriteResponse) {
              await context.sync();
              const selectedTextRange = context.presentation.getSelectedTextRangeOrNullObject();
              selectedTextRange.load("text");
              selectedTextRange.load("length");
              selectedTextRange.load("start");
              await context.sync();

              // bring cursor to end of selection
              selectedTextRange.start = selectedTextRange.start + selectedTextRange.length;
              selectedTextRange.text = "";
              selectedTextRange.length = 1;

              selectedTextRange.setSelected();

              await context.sync();
            }
            resolve(true);
          } catch (e) {
            console.log(e);
            reject(false);
          }
        });
        break;
      }
      case Office.HostType.Word: {
        await Word.run(async function (context) {
          try {
            await context.sync();
            // Create a range proxy object for the current selection.
            const range = context.document.getSelection();

            // Queue a command to insert text at the end of the selection.
            range.insertText(data + "\n", "Before");
            await context.sync();
            // Get a reference to a specific paragraph (change the paragraph index as needed)
            // const paragraph = context.document.body.paragraphs.getLastOrNullObject();
            range.select("End");
            await context.sync();
            resolve(true);
          } catch (e) {
            console.log(e);
            reject(false);
          }
        });
        break;
      }
    }
  });
}

export async function addHtml(data: string): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    switch (Office.context.host) {
      case Office.HostType.Word: {
        await Word.run(async function (context) {
          try {
            await context.sync();
            // Create a range proxy object for the current selection.
            const range = context.document.getSelection();

            // Queue a command to insert html at the end of the selection.
            range.insertHtml(data + "<br />", "Before");

            // Get a reference to a specific paragraph (change the paragraph index as needed)
            // const paragraph = context.document.body.paragraphs.getLastOrNullObject();
            range.select("End");
            await context.sync();
            resolve(true);
          } catch (e) {
            console.log(e);
            reject(false);
          }
        });
      }
    }
  });
}

export async function addNewLine(): Promise<void> {
  return new Promise(async (resolve, reject) => {
    switch (Office.context.host) {
      case Office.HostType.PowerPoint: {
        await PowerPoint.run(async function (context) {
          try {
            await context.sync();
            let selectedTextRange = context.presentation.getSelectedTextRangeOrNullObject();
            selectedTextRange.load(["text", "length", "start"]);
            await context.sync();
            selectedTextRange.start = selectedTextRange.start + selectedTextRange.length;
            selectedTextRange.text = "\n";
            selectedTextRange.length = 1;
            selectedTextRange.setSelected();
            await context.sync();
            resolve();
          } catch (e) {
            console.log(e);
            reject();
          }
        });
        break;
      }
      case Office.HostType.Word: {
        await Word.run(async function (context) {
          try {
            await context.sync();
            // Create a range proxy object for the current selection.
            const range = context.document.getSelection();
            // Queue a command to insert text at the end of the selection.
            // range.insertParagraph("", "After");
            // Get a reference to a specific paragraph (change the paragraph index as needed)
            // const paragraph = context.document.body.paragraphs.getLastOrNullObject();
            // paragraph.select("End");
            await context.sync();
            resolve();
          } catch (e) {
            console.log(e);
            reject();
          }
        });
        break;
      }
    }
  });
}

export async function addTable(data: string[][]): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    switch (Office.context.host) {
      case Office.HostType.Word: {
        await Word.run(async function (context) {
          try {
            const range = context.document.getSelection();
            const table = range.insertTable(data.length, data[0].length, "Before", data);
            table.getBorder(Word.BorderLocation.all).width = 1;
            table.getBorder(Word.BorderLocation.all).color = "#BFBFBF";
            for(let i = 0; i < data.length; i++) {
              table.getCell(i, 0).shadingColor = "#D9E2F3";
              table.getCell(i, 0).body.font.bold = true;
            }
            for(let j = 0; j < data[0].length; j++) {
              table.getCell(0, j).shadingColor = "#D9E2F3";
              table.getCell(0, j).body.font.bold = true;
            }
            table.getCell(0, 0).body.getRange().select("Start");
            await context.sync();
            resolve(true);
          } catch (error) {
            console.log(error);
            if (error instanceof OfficeExtension.Error) {
              console.log('Trace messages: ' + error.traceMessages);
          }
            reject(false);
          }
        });
      }
    }
  });
}
